import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import JoinEditor from '../editors/custom-editors/JoinEditor';
import {StepTypeConfigUISchemaV2} from '../step-config-settings/StepConfigUISchemas';
import {CUSTOM_COMPONENT_KEY, FIELD_ORDER_UI_SCHEMA_KEY} from '../StepConfigEditorTypes';

export const JOIN_V0_UI_SCHEMA: StepTypeConfigUISchemaV2<PipelineStepType.JOIN, 0> = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['join', 'dataFrameName'],
  join: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['join'],
    join: {[CUSTOM_COMPONENT_KEY]: JoinEditor},
  },
  dataFrameName: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['dataFrameName'],
    dataFrameName: {
      displayName: 'Name table',
      configShapePath: ['dataFrameName'],
    },
  },
};
